/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction, AnyAction } from "@reduxjs/toolkit";
import { ThunkDispatch } from "redux-thunk";
import _ from "lodash";
import { LoadingState } from "../../Common";
import { Tag } from "..";
import * as api from "../Api";

export type TagState = {
  loadingState: LoadingState;
  error?: string;
  tags: Tag[];
};

const initialState: TagState = {
  loadingState: {
    isLoaded: false,
    isLoading: false,
    errored: false
  },
  tags: []
};

const slice = createSlice({
  name: "tags",
  initialState,
  reducers: {
    startLoading: state => {
      state.loadingState = {
        isLoaded: false,
        isLoading: true,
        errored: false
      };
    },
    finishLoading: (state, action: PayloadAction<Tag[]>) => {
      state.loadingState = {
        isLoaded: true,
        isLoading: false,
        errored: false
      };
      state.tags = action.payload;
    },
    errorLoading: (state, action: PayloadAction<string>) => {
      state.loadingState = {
        isLoaded: false,
        isLoading: false,
        errored: true
      };
      state.error = action.payload;
    },
    invalidate: () => initialState
  }
});

export default slice.reducer;

export const { invalidate } = slice.actions;

export const load = () => async (dispatch: ThunkDispatch<unknown, unknown, AnyAction>) => {
  dispatch(slice.actions.startLoading());
  try {
    const tags = await api.getTags();
    dispatch(slice.actions.finishLoading(tags as Tag[]));
  } catch (e) {
    dispatch(slice.actions.errorLoading((e as Error).message));
  }
};
